import { FC } from "react";
import BlankProjectItem from "@/features/project/components/BlankProjectItem";
import NotFoundProjectView from "@/components/NotFoundProjectView";
import ProjectItemForCreate from "./ProjectItemForCreate";
import ProjectItemList from "./ProjectItemList";

type Props = {
  enablePost?: boolean;
};

const ProjectItemsForNotFound: FC<Props> = ({ enablePost = false }) => {
  if (!enablePost) {
    return <NotFoundProjectView />;
  }

  return (
    <ProjectItemList projects={[]}>
      <ProjectItemForCreate />
      <BlankProjectItem />
      <BlankProjectItem />
      <BlankProjectItem />
      <BlankProjectItem />
      <BlankProjectItem />
    </ProjectItemList>
  );
};

export default ProjectItemsForNotFound;
